import React, { useEffect, useRef, useState } from "react";
import "./PaymentModeDropdown.css";

const PROVIDERS = [
  { value: "razorpay", label: "Razorpay", logo: "/images/razorpay.png" },
  { value: "stripe", label: "Stripe", logo: "/images/stripe.png" },
];

export default function PaymentModeDropdown({
  label = "payment mode",
  value = "razorpay",
  onChange,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const selected =
    PROVIDERS.find((p) => p.value === value) ||
    PROVIDERS.find((p) => p.value === "razorpay");

  useEffect(() => {
    const onDocMouseDown = (e) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, []);

  const handleSelect = (next) => {
    if (disabled) return;
    if (typeof onChange === "function") onChange(next);
    setOpen(false);
  };

  return (
    <div
      className={`payment-mode ${disabled ? "payment-mode--disabled" : ""}`}
      ref={rootRef}
    >
      <div className="payment-mode__label">{label}</div>
      <button
        type="button"
        className="payment-mode__button"
        onClick={() => !disabled && setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        disabled={disabled}
      >
        <span className="payment-mode__button-left">
          <img
            className="payment-mode__logo"
            src={selected.logo}
            alt={`${selected.label} logo`}
          />
          {/* <span className="payment-mode__text">{selected.label}</span> */}
        </span>
        <span className="payment-mode__chevron" aria-hidden="true">
          ▾
        </span>
      </button>

      {open && (
        <div className="payment-mode__menu" role="listbox">
          {PROVIDERS.map((p) => (
            <button
              key={p.value}
              type="button"
              className={`payment-mode__item ${
                p.value === selected.value ? "payment-mode__item--active" : ""
              }`}
              onClick={() => handleSelect(p.value)}
              role="option"
              aria-selected={p.value === selected.value}
            >
              <img
                className="payment-mode__logo"
                src={p.logo}
                alt={`${p.label} logo`}
              />
              {/* <span className="payment-mode__text">{p.label}</span> */}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
